import { Loader } from "@eisox/design-system";

const AuthLoadingScreen: React.FC = () => (
  <div className="flex min-h-screen items-center justify-center">
    <Loader />
  </div>
);

export { AuthLoadingScreen };
